import { render, staticRenderFns } from "./BaseErrorModal.vue?vue&type=template&id=077734f4&"
import script from "./BaseErrorModal.vue?vue&type=script&lang=js&"
export * from "./BaseErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports